module.exports = __webpack_public_path__ + "img/business-meet.26801ad0.svg";